import React from "react";
import { PreviewContentLoaderTemplate } from "themes/common/components";

function PreviewContentLoader(props) {
    return <PreviewContentLoaderTemplate {...props} />;
}

export default PreviewContentLoader;
